import type { ExampleItem } from "../types";
import { exampleText, formatLabel } from "../utils/format";
import { WorkflowMarkdown } from "./WorkflowMarkdown";

/** One example input or output: what it is, its format, and the example. */
export const ExampleCard = ({ item }: { item: ExampleItem }) => (
  <li className="rounded-lg border border-zinc-200 bg-white px-3 py-2.5">
    <div className="flex flex-wrap items-start justify-between gap-2">
      <p className="min-w-0 text-sm font-semibold text-zinc-900">{item.label}</p>
      <span className="shrink-0 rounded-full bg-zinc-100 px-2 py-0.5 text-2xs font-medium text-zinc-600">
        {formatLabel(item.media_type)}
      </span>
    </div>
    {item.description && (
      <p className="mt-1 text-xs leading-relaxed text-zinc-600">{item.description}</p>
    )}
    <div
      role="region"
      aria-label={`Example: ${item.label}`}
      tabIndex={0}
      className="mt-2 max-h-80 overflow-auto rounded-md border border-zinc-200 bg-zinc-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400"
    >
      {item.media_type === "text/markdown" && typeof item.example === "string" ? (
        <div className="px-3">
          <WorkflowMarkdown>{item.example}</WorkflowMarkdown>
        </div>
      ) : (
        <pre className="whitespace-pre-wrap break-words p-3 text-2xs leading-relaxed text-zinc-800">
          {exampleText(item.example)}
        </pre>
      )}
    </div>
  </li>
);
